<template>
  <el-input
    v-bind="$attrs"
    :value="displayValue"
    :placeholder="placeholder"
    @input="handleInput"
    @focus="handleFocus"
    @blur="handleBlur"
  >
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name"></slot>
    </template>
  </el-input>
</template>

<script>
import { formatThousand, unformatThousand, stripTrailingZeros } from '@/assets/js/utils';

export default {
  name: 'PriceInput',
  inheritAttrs: false,
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    decimals: {
      type: Number,
      default: 4,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      displayValue: '',
      isFocused: false,
    };
  },
  watch: {
    value: {
      handler(val) {
        if (this.isFocused) return;
        this.syncDisplay(val);
      },
      immediate: true,
    },
  },
  methods: {
    syncDisplay(val) {
      if (this.isFocused) return;
      const raw = unformatThousand(val);
      if (raw === '' || raw === '-') {
        this.displayValue = raw;
        return;
      }
      const num = parseFloat(raw);
      if (isNaN(num)) {
        this.displayValue = raw;
        return;
      }
      this.displayValue = formatThousand(num, this.decimals);
    },

    handleInput(val) {
      let filtered = val.replace(/[^\d.]/g, '');
      const dotCount = (filtered.match(/\./g) || []).length;
      if (dotCount > 1) {
        const firstDotIdx = filtered.indexOf('.');
        filtered = filtered.slice(0, firstDotIdx + 1) + filtered.slice(firstDotIdx + 1).replace(/\./g, '');
      }
      if (filtered.startsWith('.')) {
        filtered = '0' + filtered;
      }
      const dotIdx = filtered.indexOf('.');
      if (dotIdx !== -1) {
        const intPart = filtered.slice(0, dotIdx);
        const decPart = filtered.slice(dotIdx + 1);
        if (decPart.length > this.decimals) {
          filtered = intPart + '.' + decPart.slice(0, this.decimals);
        }
      }
      this.displayValue = filtered;
    },

    handleFocus() {
      this.isFocused = true;
      const raw = this.value == null ? '' : String(this.value);
      this.displayValue = unformatThousand(raw);
    },

    handleBlur() {
      this.isFocused = false;
      const raw = unformatThousand(this.displayValue);
      if (raw === '' || raw === '0' || raw === '-') {
        this.displayValue = raw;
        this.$emit('input', raw === '' ? '' : parseFloat(raw) || 0);
        return;
      }
      const num = parseFloat(raw);
      if (isNaN(num)) {
        this.displayValue = raw;
        this.$emit('input', raw);
        return;
      }
      const stripped = stripTrailingZeros(raw);
      this.displayValue = formatThousand(num, this.decimals);
      this.$emit('input', parseFloat(stripped) || 0);
      this.$emit('change', parseFloat(stripped) || 0);
    },
  },
};
</script>
